import { IFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'

export type IBlueprintType =
  | 'error'
  | 'deconstruct-hull'
  | 'construct-hull'
  | 'mine'
  | 'build'
  | 'debuild'
  | 'cancel'

export interface IBlueprintData {
  idx: number
  type: IBlueprintType
  frame: IFrameInfo
}

const defaultData: IBlueprintData = {
  idx: -1,
  type: 'error',
  frame: frameInfo.fi32(5, 2, 10),
}

export const dataList: IBlueprintData[] = []
export const dataMapIdx: { [key: number]: IBlueprintData } = {}
export const dataMapName: { [key: string]: IBlueprintData } = {}
// [key in IBlueprintType]?: IBlueprintData

export function addBlueprint(
  idx: number,
  type: IBlueprintType,
  data: Partial<IBlueprintData>,
) {
  let d = Object.assign({}, defaultData, data, {
    idx,
    type,
  })
  Object.freeze(d)
  dataList.push(d)
  dataMapIdx[idx] = d
  dataMapName['' + type] = d
}

export const createData = () => {
  addBlueprint(0, 'deconstruct-hull', { frame: frameInfo.fi32(5, 2, 10) })
  addBlueprint(1, 'construct-hull', { frame: frameInfo.fi32(5, 2, 11) })
  addBlueprint(2, 'mine', { frame: frameInfo.fi32(5, 2, 12) })
  addBlueprint(3, 'build', { frame: frameInfo.fi32(5, 2, 11) })
  addBlueprint(4, 'cancel', { frame: frameInfo.fi32(5, 2, 13) })
  addBlueprint(5, 'debuild', { frame: frameInfo.fi32(5, 2, 10) })
}
